/**
 * 竞价实时信息大屏显示
 */
import React from 'react';
import { Row, Col, Carousel, Modal } from 'antd';

import "./LargeScreenStyle.css";
import "./HeadBanner.css";
import logoImg from "./img/logo.png";
// import waitBeginImg from "./img/waitBegin.png";
import completeImg from "./img/complete.png";
import auctionIngImg from "./img/auctioning.png";
import restImg from "./img/rest.png";
import waitBeginImg from "./img/waitBegin.png";
import backgroundImg from "./img/background1.jpg";

import dealImg from "./img/deal.png";
import failImg from "./img/fail2.png";
import lowPriceImg from "./img/lowPrice.png";
import "../../../style/ui/icon.css"
import moment from 'moment';
import server from '../../../axios/server';
import http from '../../../axios/http';
import { numFormat, getUrlParam } from '../../../util/util';

const weekMap = {
    "1": "一",
    "2": "二",
    "3": "三",
    "4": "四",
    "5": "五",
    "6": "六",
    "0": "日",
}

class AuctionPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            sessionId: "",
            time: "",
            date: "",
            firstWxConn: true,
            countDownFlag: false,    //倒计时标识
            countDownNum: 5,
            nextLotsData: {},
            partakeNumber: 0,  // 参与人数
            displayCount: false,    //是否显示倒计时
            displayResult: false,   //是否显示竞价结果
            isDeal: false,          //竞价结果是否成交
            islowPrice: false,          //竞价结果是否低于保留价
            countText: "距开始",    //倒计时标签文字
            countDownTime: '',      //倒计时时间
        };
    }

    initAuctionTaskData = (sessionId, lotsId) => {
        //竞拍数据
        http.get({
            url: '/auction/largescreen/auctionTask?sessionId=' + sessionId,
            success: (item) => {
                if (item === null) {
                    window.location.replace(window.location.origin + "/large/lotsDetail/" + lotsId);
                }
                else {
                    http.get({
                        url: '/auction/largescreen/findMemberAbbreviationMap',
                        success: (map) => {
                            const websocketUrl = server.websocketUrl + "/wxAuction/ws/" + sessionId;
                            this.ws = new WebSocket(websocketUrl);
                            this.ws.onopen = this.onopen;
                            this.ws.onmessage = this.onmessage;
                            this.ws.onclose = this.onclose;
                            let vehicleImages = this.getVehicleImagesFromVehicleInfo(item.vehicleInfo);
                            //图片链接
                            this.generateImageUrls(vehicleImages);
                            //初始化出价记录和当前价格
                            let records = item.records;
                            let currentMoney = item.auctionLotVO.startPrice;
                            let currentMoneyStr = numFormat(currentMoney);
                            item.auctionLotVO.startPriceStr = numFormat(item.auctionLotVO.startPrice);
                            if (records !== undefined && records !== null && records.length > 0) {
                                currentMoney = records[0].offer;
                                currentMoneyStr = numFormat(currentMoney);
                            }
                            
                            this.setState({
                                item: item,
                                vehicleInfo: item.vehicleInfo,
                                auctionLotVO: item.auctionLotVO,
                                currentMoney: currentMoney,
                                currentMoneyStr: currentMoneyStr,
                                status: item.status,
                                records: records,
                                currentLotsId: item.currentLotsId,
                                startTime: item.startTime,
                                endTime: item.endTime,
                                currentLotsIndex: item.currentLotsIndex,
                                userMemberMap: map,
                            })
                        }
                    });
                }
            }
        });
    }


    //获取车辆图片，包括左前脸照片
    getVehicleImagesFromVehicleInfo(vehicleInfo) {
        let vehicleImages = vehicleInfo.vehicleImages;
        if (vehicleImages !== null && vehicleImages !== undefined) {
            vehicleImages.unshift(vehicleInfo.leftFrontImage);
        }
        else {
            vehicleImages = [];
            vehicleImages.unshift(vehicleInfo.leftFrontImage);
        }
        return vehicleImages;
    }

    generateImageUrls(vehicleImages) {
        let imageUrls = [];
        if (vehicleImages !== undefined && vehicleImages !== null && vehicleImages.length > 0) {
            vehicleImages.forEach((item, index) => {
                http.post({
                    url: "/common/getOriginalImage",
                    data: { url: item },
                    success: (res) => {
                        imageUrls.push("data:image/jpeg;base64," + res);
                        if (imageUrls.length === vehicleImages.length) {
                            this.setState({
                                imageUrls: imageUrls,
                            })
                        }
                    }
                })
            });
        }
    }

    componentDidMount() {
        let now = new moment();
        let time = now.format("H:mm:ss");
        let date = now.format("YYYY年M月D日 ");
        let day = now.day() + "";
        //初始化车辆图片和车辆信息
        let sessionId = getUrlParam("sessionId");
        let lotsId = getUrlParam("lotsId");
        if (sessionId) {
            this.initAuctionTaskData(sessionId, lotsId);
            this.setState ({
                sessionId: sessionId,
                time: time,
                date: date + "星期" + weekMap[day],
                firstWxConn: true,
                countDownFlag: false,    //倒计时标识
                countDownNum: 5,
                nextLotsData: {},
                partakeNumber: 0,  // 参与人数
                displayCount: false,    //是否显示倒计时
                displayResult: false,   //是否显示竞价结果
                isDeal: false,          //竞价结果是否成交
                islowPrice: false,          //竞价结果是否低于保留价
                countText: "距开始",    //倒计时标签文字
                countDownTime: '',      //倒计时时间
            });
        }
       

        //设置竞价倒计时
        this.countdown();
        //设置右上角的时间
        this.initTime();
        this.timerID = setInterval(() => this.initTime(), 1000);
        //设置轮播图自动切换定时任务
        this.carouselTimer = setInterval(() => this.nextCarousel(), 4000);
    }

    addZero(i) {
        return i < 10 ? "0" + i : i + "";
    }

    onopen = (evt) => {
    }

    onmessage = (evt) => {
        let data = evt.data;
        data = JSON.parse(data);
        data = data.data;
        let status = data.status;
        let firstWxConn = this.state.firstWxConn;
        //初始化出价记录和当前价格
        let records = data.records;
        let currentMoney = this.state.currentMoney;
        let currentMoneyStr = this.state.currentMoneyStr;

        if (records !== undefined && records !== null && records.length > 0) {
            currentMoney = records[0].offer;
            currentMoneyStr = numFormat(currentMoney)
        }
        if (status === 3 && !firstWxConn) {
            //显示竞价结果，进入倒计时5s
            this.setState({
                countDownFlag: true,    //倒计时标识
                countDownNum: 5,
                nextLotsData: data
            })
        }
        else {
            //修正当前竞价物信息
            if (data.currentLotsId !== this.state.currentLotsId) {
                this.updateLotsInfo(data.currentLotsId, data.currentLotsIndex);
            }
            //更新竞拍信息
            this.setState({
                startTime: data.startTime,
                endTime: data.endTime,
                status: status,
                records: data.records,
                currentLotsId: data.currentLotsId,
                currentLotsIndex: data.currentLotsIndex,
                currentMoney: currentMoney,
                currentMoneyStr: currentMoneyStr,
                firstWxConn: false,
                partakeNumber: data.number,  //参与人数
            });
        }
        if (this.countdownTimer) {
            clearTimeout(this.countdownTimer);
        }
        this.countdown();
    }

    nextLots = () => {
        let data = this.state.nextLotsData;
        //进入下一竞拍物
        let lotsList = this.state.item.lotsList;
        let currentLotsId = data.currentLotsId;
        let currentLotsIndex = data.currentLotsIndex;
        if (lotsList !== null && lotsList !== undefined) {
            currentLotsId = lotsList[this.state.currentLotsIndex + 1].id;
            currentLotsIndex = currentLotsIndex + 1;
            http.get({
                url: '/auction/largescreen/lotsInfo',
                data: { lotsId: currentLotsId },
                success: (res) => {
                    if (res !== null && res !== undefined) {
                        let vehicleImages = this.getVehicleImagesFromVehicleInfo(res.vehicleInfo);
                        this.generateImageUrls(vehicleImages);
                        res.auctionLotVO.startPriceStr = numFormat(res.auctionLotVO.startPrice)
                        this.setState({
                            vehicleInfo: res.vehicleInfo,
                            auctionLotVO: res.auctionLotVO,
                            currentLotsId: currentLotsId,
                            currentLotsIndex: currentLotsIndex,
                            currentMoney: res.auctionLotVO.startPrice,
                            currentMoneyStr: numFormat(res.auctionLotVO.startPrice),
                            status: data.status,
                            records: [],
                            startTime: data.startTime,
                            endTime: data.endTime,
                            firstWxConn: false
                        });
                    }
                }
            });
        }
    }

    updateLotsInfo = (currentLotsId, currentLotsIndex) => {
        http.get({
            url: '/auction/largescreen/lotsInfo',
            data: { lotsId: currentLotsId },
            success: (res) => {
                if (res !== null && res !== undefined) {
                    let vehicleImages = this.getVehicleImagesFromVehicleInfo(res.vehicleInfo);
                    this.generateImageUrls(vehicleImages);
                    res.auctionLotVO.startPriceStr = numFormat(res.auctionLotVO.startPrice)
                    this.setState({
                        vehicleInfo: res.vehicleInfo,
                        auctionLotVO: res.auctionLotVO,
                        currentLotsId: currentLotsId,
                        currentLotsIndex: currentLotsIndex,
                        currentMoney: res.auctionLotVO.startPrice,
                        currentMoneyStr: numFormat(res.auctionLotVO.startPrice),
                        records: [],
                        firstWxConn: false
                    });
                }
            }
        });
    }

    onclose = (res) => {
        //如果是正常页面关闭 res = {code: 1000, reason: "normal closure"}
        //如果是服务停止 res = {code: 1006, reason: "abnormal closure"}
        //如果是电话进来导致socket停止 res = {code: 1000, reason: "interrupted"}
        // console.log("web socket close...");
        // console.log(res);
        // eslint-disable-next-line eqeqeq
        if (res.reason == "normal closure" || res.reason == "interrupted" || (res.code == 1006 && res.reason == "")) {
            //正常结束或后台关闭，不做处理
        } else {
            //进行重连操作
            console.log("websocket 异常断开，尝试重连...");
            const websocketUrl = server.websocketUrl + "/wxAuction/ws/" + this.state.sessionId;
            this.ws = new WebSocket(websocketUrl);
            this.ws.onopen = this.onopen;
            this.ws.onmessage = this.onmessage;
            this.ws.onclose = this.onclose;
        } 
    };

    initTime = () => {
        let now = new moment();
        let time = now.format("H:mm:ss");
        let date = now.format("YYYY年M月D日 ");
        let day = now.day() + "";
        this.setState({
            time: time,
            date: date + "星期" + weekMap[day]
        });
    }

    countdown = () => {
        const { status, startTime, endTime, countDownFlag, countDownNum } = this.state;
        let displayCount = this.state.displayCount;
        let displayResult = this.state.displayResult;
        let isDeal = this.state.isDeal;
        let countText = this.state.countText;
        let islowPrice = this.state.islowPrice;
        let now = new Date();

        let lefttime = 300;
        //全场已结束
        if (status === 2) {
            const { currentMoney, auctionLotVO, records } = this.state;
            let reservePrice = auctionLotVO.reservePrice;
            if (reservePrice === null || reservePrice === undefined) {
                reservePrice = auctionLotVO.startPrice;
            }
            if (currentMoney >= reservePrice && records !== undefined && records !== null && records.length > 0) {
                displayResult = true;
                displayCount = false;
                isDeal = true;
                islowPrice = false;
            }
            else if (records === undefined || records === null || records.length === 0) {
                displayResult = true;
                displayCount = false;
                isDeal = false;
                islowPrice = false;
            }
            else {
                displayResult = true;
                displayCount = false;
                isDeal = false;
                islowPrice = true;
            }
            this.setState({
                displayResult: displayResult,
                displayCount: displayCount,
                isDeal: isDeal,
                islowPrice: islowPrice
            });
            return;
        } else if (status === 1 && countDownFlag) {
            //单个竞价结束，显示竞价结果和5秒倒计时，即将进入幕间休息
            const { currentMoney, auctionLotVO, records } = this.state;
            let reservePrice = auctionLotVO.reservePrice;
            if (reservePrice === null || reservePrice === undefined) {
                reservePrice = auctionLotVO.startPrice;
            }
            if (currentMoney >= reservePrice && records !== undefined && records !== null && records.length > 0) {
                displayResult = true;
                displayCount = false;
                isDeal = true;
                islowPrice = false;
            }
            else if (records === undefined || records === null || records.length === 0) {
                displayResult = true;
                displayCount = false;
                isDeal = false;
                islowPrice = false;
            }
            else {
                //低于保留价
                displayResult = true;
                displayCount = false;
                isDeal = false;
                islowPrice = true;
            }
            if (countDownNum > 0) {
                this.setState({
                    displayResult: displayResult,
                    displayCount: displayCount,
                    isDeal: isDeal,
                    islowPrice: islowPrice,
                    countDownNum: countDownNum - 1
                });
            }
            else {
                this.setState({
                    displayResult: displayResult,
                    displayCount: displayCount,
                    isDeal: isDeal,
                    islowPrice: islowPrice,
                    countDownNum: 5,
                    countDownFlag: false
                });
                this.nextLots()
            }
            this.countdownTimer = setTimeout(() => this.countdown(), 1000);
            return;
        } else if (status === 0 || status === 3) {
            //竞价还没开始或者幕间休息
            lefttime = parseInt(startTime - now.getTime());
            if (lefttime < 0) {
                lefttime = 0;
            }
            displayResult = false;
            displayCount = true;
            countText = "距开始";
        } else if (status === 1) {
            //竞价进行中
            lefttime = parseInt(endTime - now.getTime());
            if (lefttime < 0) {
                lefttime = 0;
            }
            displayResult = false;
            displayCount = true;
            countText = "距结束";
        }
        let h = parseInt(lefttime / 1000 / (60 * 60) % 24);
        let m = parseInt(lefttime / 1000 / 60 % 60);
        let s = parseInt(lefttime / 1000 % 60);
        let ms = parseInt(lefttime % 1000);
        h = this.addZero(h);
        m = this.addZero(m);
        s = this.addZero(s);
        ms = ms >= 100 ? ms + "" : (ms >= 10 ? "0" + ms : "00" + ms);
        //倒计时时间
        let countDownTime = h + " : " + m + " : " + s + " . " + ms;
        this.setState({
            displayResult: displayResult,
            displayCount: displayCount,
            isDeal: isDeal,
            countText: countText,
            countDownTime: countDownTime,
            countDownNum: 5
        });
        this.countdownTimer = setTimeout(() => this.countdown(), 100);
    }
    componentWillUnmount() {
        clearInterval(this.timerID);
        clearInterval(this.carouselTimer);
    }

    //生成轮播图车辆图片
    createVehicleImagesDoms = () => {
        const { imageUrls } = this.state;
        let doms = [];
        if (imageUrls !== undefined && imageUrls !== null && imageUrls.length > 0) {
            imageUrls.forEach((item, index) => {
                doms.push((<div key={index}>
                    <div className="slider-item" style={{ width: '100%', height: '44.4vh', minHeight: '400px', background: "url(" + item + ") no-repeat center center", backgroundSize: "cover" }}>
                    </div>
                </div>));
            });
        }
        return doms;
    }

    //出价记录
    createBidTable() {
        const { records, auctionLotVO } = this.state;
        const userMemberMap = this.state.userMemberMap;
        let doms = [];
        let showBidder = auctionLotVO.showBidder === 1;
        if (records !== undefined && records !== null && records.length > 0) {
            let length = records.length;
            for (let i = 0; i < records.length && i < 40; i++) {
                //第0个出价为成功
                let status = i === 0 ? "最高价" : "已出局";
                let className = "table-bid-record";
                if (i === 0) {
                    className = "table-bid-record highest-price";
                }
                let item = records[i];
                let username = item.username;
                let memberCode = item.memberCode;
                if (!showBidder) {
                    username = "*****";
                }
                else {
                    username = userMemberMap[memberCode];
                    // if (username === null || username === undefined) {
                    //     username = item.username;
                    // } 
                }
                let dom = (
                    <Row className='bid-row' key={i}>
                        <Col className={className} span={5}>{length - i}</Col>
                        <Col className={className} span={5}>{status}</Col>
                        <Col className={className} span={8}>{username}</Col>
                        <Col className={className} span={6}>{numFormat(item.offer)}</Col>
                    </Row>
                );
                doms.push(dom);
            }
        }
        else {
            doms.push((
                <div key="record-empty" className="empty-data">暂无数据</div>
            ));
        }
        return doms;
    }

    nextCarousel = () => {
        if (this.refs.carousel) {
            this.refs.carousel.next();
        }
    }

    render() {
        const { item, status, auctionLotVO, vehicleInfo, displayResult, displayCount,
            isDeal, countText, islowPrice, countDownTime, currentLotsIndex, countDownFlag, countDownNum } = this.state;
        if (!item) {
            return (<div></div>)
        }
        else {
            let size = item.lotsList.length;
            return (
                <div className="root" style={{ background: 'url(' + backgroundImg + ') no-repeat', backgroundSize: 'cover' }}>
                    <div className="head" style={{ textAlign: 'center' }}>
                        <div className="head-container">
                            <div className='head-left head-div'>
                                <img className="head-logo-img" src={logoImg} alt="logo" />
                                <div className="head-logo-text">厦门二手车交易市场网上竞价大厅</div>
                            </div>
                            <div className='head-center head-div'>
                                <img className="head-status-img" src={status === 0 ? waitBeginImg : (status === 1 ? auctionIngImg : (status === 3 ? restImg : completeImg))} alt="status" />
                            </div>
                            <div className='head-right head-div'>
                                <span className="head-right-time">{this.state.time}</span><br />
                                <span className="head-right-date">{this.state.date}</span>
                            </div>
                        </div>
                    </div>
                    <div className='main-container'>
                        <div className="main">
                            <div className="main-left main-background">
                                <div className="left-top car-detail">
                                </div>
                                <div className="left-item">
                                    <span className="left-item-data">{vehicleInfo.brandModel}</span><br />
                                    <span className="left-item-field">品牌型号</span>
                                </div>
                                <div className="left-item">
                                    <span className="left-item-data">{vehicleInfo.plateNo}</span><br />
                                    <span className="left-item-field">车牌号</span>
                                </div>
                                <div className="left-item">
                                    <span className="left-item-data">{vehicleInfo.registerDate}</span><br />
                                    <span className="left-item-field">初登日期</span>
                                </div>
                                <div className="left-item">
                                    <span className="left-item-data">{vehicleInfo.registerLocation}</span><br />
                                    <span className="left-item-field">初次登记地</span>
                                </div>
                                <div className="left-item">
                                    <span className="left-item-data">{vehicleInfo.vin}</span><br />
                                    <span className="left-item-field">VIN码</span>
                                </div>
                                <div className="left-item">
                                    <span className="left-item-data">{vehicleInfo.useProperty}</span><br />
                                    <span className="left-item-field">使用性质</span>
                                </div>
                                <div className="left-item">
                                    <span className="left-item-data">{vehicleInfo.seatNum ? vehicleInfo.seatNum : "未知"}</span><br />
                                    <span className="left-item-field">座位数</span>
                                </div>
                                <div className="left-item">
                                    <span className="left-item-data">{vehicleInfo.transferTimes}</span><br />
                                    <span className="left-item-field">过户次数</span>
                                </div>
                                <div className="left-item">
                                    <span className="left-item-data">{vehicleInfo.mileage}公里</span><br />
                                    <span className="left-item-field">表显里程</span>
                                </div>
                                <div className="left-item">
                                    <span className="left-item-data">{vehicleInfo.displacement}</span><br />
                                    <span className="left-item-field">发动机排量</span>
                                </div>
                                <div className="left-item">
                                    <span className="left-item-data">{vehicleInfo.gearBox}</span><br />
                                    <span className="left-item-field">变速箱类型</span>
                                </div>
                                <div className="left-item">
                                    <span className="left-item-data">{vehicleInfo.driveMode}</span><br />
                                    <span className="left-item-field">驱动方式</span>
                                </div>
                                <div className="left-item">
                                    <span className="left-item-data">{vehicleInfo.commerciaInsuranceDate ? vehicleInfo.commerciaInsuranceDate : "未录入"}</span><br />
                                    <span className="left-item-field">商业险到期</span>
                                </div>
                                <div className="left-item">
                                    <span className="left-item-data">{vehicleInfo.mandatoryInsuranceDate ? vehicleInfo.mandatoryInsuranceDate : "未录入"}</span><br />
                                    <span className="left-item-field">交强险到期</span>
                                </div>
                                <div className="left-item">
                                    <span className="left-item-data">{vehicleInfo.examinationDate ? vehicleInfo.examinationDate : "未录入"}</span><br />
                                    <span className="left-item-field">车检到期</span>
                                </div>
                                <div className="left-item">
                                    <span className="left-item-data">{vehicleInfo.fueltype}</span><br />
                                    <span className="left-item-field">能源类型</span>
                                </div>
                            </div>
                            <div className="main-center main-background">
                                <div className="main-slider">
                                    <Carousel ref="carousel">
                                        {this.createVehicleImagesDoms()}
                                    </Carousel>
                                    {displayCount ? <div className='countdown-bar'>
                                        <i className='countdown-icon iconfont icon-clock'>
                                        </i>
                                        <span className='countdown-time'><span className='countdown-text'>&nbsp;&nbsp;{countText} </span>{countDownTime}</span>
                                        <div className="gradient-div1">
                                            <img id="waiteBegin-img" src={status === 0 || status === 3 ? waitBeginImg : auctionIngImg} alt="waiteBegin-img" />
                                        </div>
                                    </div> : ''}
                                    {displayResult ? <img className="auction-result-tag" src={isDeal ? dealImg : (islowPrice ? lowPriceImg : failImg)} alt="auction-result" /> : ''}
                                </div>
                                <div className="center-name-box">
                                    <span className="car-name1">{auctionLotVO.name}</span>
                                    <span className="car-number">车辆编号:  {auctionLotVO.code}</span>
                                </div>
                                <div className='center-detail'>
                                    <div className="center-detail-item">
                                        <div className='detail-icon iconfont icon-clock'>
                                        </div>
                                        <div className='detail-info'>
                                            <span className="left-item-data">{vehicleInfo.registerDate}</span><br />
                                            <span className="left-item-field">初登日期</span>
                                        </div>
                                    </div>

                                    <div className="center-detail-item">
                                        <div className='detail-icon iconfont icon-mileage'>
                                        </div>
                                        <div className='detail-info'>
                                            <span className="left-item-data">{vehicleInfo.mileage}公里</span><br />
                                            <span className="left-item-field">表显里程</span>
                                        </div>
                                    </div>

                                    <div className="center-detail-item">
                                        <div className='detail-icon iconfont icon-gear'>
                                        </div>
                                        <div className='detail-info'>
                                            <span className="left-item-data">{vehicleInfo.gearBox}</span><br />
                                            <span className="left-item-field">变速箱类型</span>
                                        </div>
                                    </div>

                                    <div className="center-detail-item">
                                        <div className='detail-icon iconfont icon-displacement'>
                                        </div>
                                        <div className='detail-info'>
                                            <span className="left-item-data">{vehicleInfo.displacement}</span><br />
                                            <span className="left-item-field">发动机排量</span>
                                        </div>
                                    </div>
                                </div>
                                <div className='main-center-bottom-box padding-left'>
                                    <span className='price-label'>起始价</span>
                                    <span className='price-tag'>￥{auctionLotVO.startPriceStr}</span>
                                </div>
                                <div className='main-center-bottom-box'>
                                    <span className='price-label'>最高价</span>
                                    <span className='price-tag red-color'>￥{this.state.currentMoneyStr}</span>
                                </div>
                                <div className='main-center-follow'>
                                    <span className='follow-label'><span className='follow-label red-color font-Gilroy'>{this.state.partakeNumber ? this.state.partakeNumber : '0'}</span> &nbsp;&nbsp;人参与</span><br />
                                    <span className='follow-label'><span className='follow-label red-color font-Gilroy'>{auctionLotVO.followNum ? auctionLotVO.followNum : '0'}</span> &nbsp;&nbsp;人关注</span><br />
                                </div>
                            </div>
                            <div className="main-right main-background">
                                <div className="right-top">
                                </div>
                                <Row className='bid-table-head'>
                                    <Col span={5}>
                                        <div className="table-head-text">
                                            序号
                                            </div>
                                    </Col>
                                    <Col span={5}>
                                        <div className="table-head-text">
                                            状态
                                            </div>
                                    </Col>
                                    <Col span={8}>
                                        <div className="table-head-text">
                                            竞价用户
                                            </div>
                                    </Col>
                                    <Col span={6}>
                                        <div className="table-head-text">
                                            出价
                                            </div>
                                    </Col>
                                </Row>
                                {this.createBidTable()}
                            </div>
                        </div>
                    </div>

                    <div className='show-count'>{item.sessionName}&nbsp;{currentLotsIndex + 1} / {size}</div>
                    <Modal
                        width={300}
                        visible={countDownFlag}
                        maskClosable={false}
                        footer={null}
                    ><div style={{ fontSize: "20px", width: "100%", textAlign: "center", marginTop: "15px" }}>即将进入下一个竞价品</div>
                        <div style={{ fontSize: "40px", width: "100%", textAlign: "center", marginTop: "10px", color: "red" }}>{countDownNum}</div></Modal>
                </div>);
        }
    }
}

export default AuctionPage;